import { SagaIterator } from 'redux-saga';
import { takeEvery, takeLatest } from 'redux-saga/effects';

import {
  EditSimulation,
  EnterSimulationSubspace,
  SimulationCountsRequest
} from '~src/bootstrap/redux/actions/AppActionTypes';

import { handleEditSimulation } from './EditSimulationSaga';
import { handleEnterSimulationSubspace } from './EnterSimulationSpaceSaga';
import { handleSimulationCountsRequest } from './SimulationCountsRequestSaga';

export function* rootSimulationSaga(): SagaIterator {
  yield takeEvery(EditSimulation, handleEditSimulation);
  yield takeLatest(EnterSimulationSubspace, handleEnterSimulationSubspace);
  yield takeLatest(SimulationCountsRequest, handleSimulationCountsRequest);
}
